var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

function RadioGroupWidget(props) {
    var label = props.label,
        title = props.title,
        value = props.value,
        readonly = props.readonly,
        disabled = props.disabled,
        autofocus = props.autofocus,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        options = props.options,
        schema = props.schema,
        formContext = props.formContext,
        registry = props.registry,
        otherProps = _objectWithoutProperties(props, ['label', 'title', 'value', 'readonly', 'disabled', 'autofocus', 'onBlur', 'onFocus', 'options', 'schema', 'formContext', 'registry']);

    // Generating a unique field name to identify this set of radio buttons


    var name = Math.random().toString();
    var enumOptions = options.enumOptions;
    // checked={checked} has been moved above name={name}, As mentioned in #349;
    // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.


    var handleChange = function handleChange(event, value) {
        return otherProps.onChange(value);
    };

    return React.createElement(
        FormControl,
        { component: 'fieldset' },
        React.createElement(
            FormLabel,
            { component: 'legend' },
            label || title
        ),
        React.createElement(
            RadioGroup,
            _extends({
                classes: {
                    root: 'fd-radio-group'
                },
                value: value + ''
            }, otherProps, {
                onChange: handleChange,
                onBlur: onBlur && function (event) {
                    return onBlur(otherProps.id, event.target.value);
                },
                onFocus: onFocus && function (event) {
                    return onFocus(otherProps.id, event.target.value);
                },
                name: name
            }),
            enumOptions.map(function (option, index) {
                return React.createElement(FormControlLabel, {
                    key: index,
                    name: name,
                    disabled: schema.disabled,
                    value: option.value + '',
                    label: option.label + '',
                    control: React.createElement(Radio, { checked: option.value == value })
                });
            })
        )
    );
}

RadioGroupWidget.defaultProps = {
    autofocus: false
};

RadioGroupWidget.propTypes = process.env.NODE_ENV !== "production" ? {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
        enumOptions: PropTypes.array,
        inline: PropTypes.bool
    }).isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func
} : {};

export default RadioGroupWidget;